import { Component, HostBinding, Input } from '@angular/core'
import {
    LandingPageCurveDirectionX,
    LandingPageCurveDirectionY,
} from '@landing-page/components/curve/landing-page-curve.model'

@Component({
    selector: 'app-landing-page-curve',
    templateUrl: './landing-page-curve.component.html',
    styleUrls: ['./landing-page-curve.component.scss'],
})
export class LandingPageCurveComponent {
    @Input() direction?: [
        LandingPageCurveDirectionX,
        LandingPageCurveDirectionY,
    ]

    @HostBinding('style.--scaleX')
    get scaleX() {
        return this.direction && this.direction[0] === 'left' ? -1 : 1
    }

    @HostBinding('style.--scaleY')
    get scaleY() {
        return this.direction && this.direction[1] === 'down' ? -1 : 1
    }
}
